module.exports = __webpack_public_path__ + "img/iterac.894bbf63.svg";